import { setEntity as setEntityDiagram } from '@process-advisor/process-miner/processMiner/processMiner';

export type Props = {
    entity?: string;
    initial?: boolean;
}

export const setEntity = ({entity, initial}: Props) => {
    setEntityDiagram({entity, initial})
};

